/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
'use strict';

module.exports = {
  initODS: function initODS() {},
  handleExtensionCausedError: function handleExtensionCausedError() {}
};


//////////////////
// WEBPACK FOOTER
// ./~/draft-js/lib/DraftEffects.js
// module id = 879
// module chunks = 0